import { FieldType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import __ from "src/utils/Translations";

/**
 * Converts a field type to its human-readable label.
 *
 * This function takes a field type and returns a localized string representation
 * that describes the field type in a user-friendly way.
 *
 * @param fieldType - The type of field to get a label for. If undefined, an empty string is returned.
 * @returns A localized string representing the human-readable label for the given field type.
 * If the field type is not recognized, the field type itself is returned as a fallback.
 */
export default (fieldType?: FieldType): string => {
  if (!fieldType) return "";

  const fieldTypeLabels: Record<FieldType, string> = {
    [FieldType.TEXT]: "Pole tekstowe",
    [FieldType.DATE]: "Data",
    [FieldType.CHECKBOX]: "Zaznaczenie (checkbox)",
    [FieldType.CHOICE_SELECTION]: "Lista wyboru",
    [FieldType.INFORMATION]: "Pole informacyjne",
  };

  return __(fieldTypeLabels[fieldType] || fieldType);
};
